module.exports = __webpack_public_path__ + "static/media/icon.245e5c9e.png";